import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'bergh-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

  @Input() progressBar: boolean = false;
  @Input() progressPercentage: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}
